<i18n src="./resources/locales.json"></i18n>
<template>
  <div>
    <div class="section-title xtium-title">{{ $t('organizationSummary.yourOrganization') }}</div>
    <v-card class="organization-card my-2 background-surface-base">
      <EcsLoading :display="isLoading" />
      <v-card-text v-if="!isLoading" class="card-content d-flex flex-column">
        <div class="d-flex flex-row flex-wrap flex-grow-1">
          <div class="organization-name d-flex align-center flex-grow-1">{{ organizationName }}</div>
          <div>{{ $t('organizationSummary.platform', [productVersion]) }}</div>
        </div>
        <div>
          <div class="organization-info-item">
            {{ $t('organizationSummary.channels', [channels]) }}
          </div>
          <div class="organization-info-item">
            {{ $t('organizationSummary.businessProcesses', [businessProcesses]) }}
          </div>
          <div class="organization-info-item">
            {{ $t('organizationSummary.agents', [agents]) }}
          </div>
          <div class="organization-info-item">
            {{ $t('organizationSummary.supervisors', [supervisors]) }}
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import EcsLoading from '@/components/ecs-spinner/EcsLoading';

export default {
  name: 'EcsOrganizationSummary',
  components: { EcsLoading },
  props: {
    organizationName: {
      type: String,
      required: true
    },
    productVersion: {
      type: String,
      required: true
    },
    channels: {
      type: Number,
      required: true
    },
    agents: {
      type: Number,
      required: true
    },
    businessProcesses: {
      type: Number,
      required: true
    },
    supervisors: {
      type: Number,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style scoped>
.organization-card {
  height: 200px;
}
.organization-name {
  font-weight: 500;
  font-size: 32px;
  line-height: 32px;
}
.organization-info-item {
  line-height: 18px;
  font-size: 16px;
}
.section-title {
  color: var(--v-primary-base);
  text-transform: uppercase;
}
.card-content {
  height: 100%;
}
</style>
